import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Modal, Input, Button, message } from 'antd'
import { approveMySubOrder, rejectMySubOrder } from '../../../HttpRequests/subOrders'

const { TextArea } = Input

const ApproveRejectModal = props => {
  const {
    visible,
    action, // 'approve' or 'reject'
    subOrderId,
    onClose,
    onSuccess,
  } = props

  const [notes, setNotes] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async () => {
    setSubmitting(true)
    
    try {
      if (action === 'approve') {
        await approveMySubOrder({ id: subOrderId, data: { notes } })
        message.success('Order approved successfully')
      } else {
        await rejectMySubOrder({ id: subOrderId, data: { notes } })
        message.success('Order rejected successfully')
      }
      
      onSuccess()
      onClose()
    } catch (error) {
      message.error('Failed to update order')
      console.error(error)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      title={action === 'approve' ? 'Approve Order' : 'Reject Order'}
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type={action === 'approve' ? 'primary' : 'danger'}
          loading={submitting}
          onClick={handleSubmit}
        >
          {action === 'approve' ? 'Approve' : 'Reject'}
        </Button>,
      ]}
    >
      <div style={{ marginBottom: 8 }}>
        <strong>Notes:</strong>
      </div>
      <TextArea
        rows={4}
        value={notes}
        onChange={e => setNotes(e.target.value)}
        placeholder="Enter your notes here..."
      />
    </Modal>
  )
}

ApproveRejectModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  action: PropTypes.oneOf(['approve', 'reject']).isRequired,
  subOrderId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}

export default ApproveRejectModal
